import { render, staticRenderFns } from "./SkeletonScreen.vue?vue&type=template&id=2c2b8a50&scoped=true&"
import script from "./SkeletonScreen.vue?vue&type=script&lang=js&"
export * from "./SkeletonScreen.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonScreen.vue?vue&type=style&index=0&id=2c2b8a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b8a50",
  null
  
)

export default component.exports